module.exports = __webpack_public_path__ + "media/images/footer_page/about/about-1-9540f9072eb679e0f1338269f0f2b0fc.png";